<template>
  <div class="fade-container">
    <slot></slot>
  </div>
</template>

<style scoped>
.fade-container {
  position: relative;

  &::before {
    content: '';

    position: absolute;
    z-index: -1;
    top: 0;
    right: 0;
    left: 0;

    display: block;

    height: 240px;

    background-color: var(--background-primary);

    mask-image: linear-gradient(180deg, #d9d9d9 0%, rgb(217 217 217 / 0%) 100%);
  }
}
</style>
